import { CatalogRouting } from '@aipb/catalog/shared/routing';
import { FrameService } from '@aipb/frame/data-access';
import { AuthRepository, AuthService } from '@aipb/auth';
import { baseUrl } from '@aipb/util/routing';

import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLinkWithHref } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'aipb-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  imports: [MatCardModule, TranslocoModule, MatButtonModule, RouterLinkWithHref]
})
export class NotAuthorizedComponent implements OnInit {
  constructor(
    private frame: FrameService,
    private auth: AuthService,
    private authRepository: AuthRepository,
    private catalogRouting: CatalogRouting
  ) {
    this.frame.setStaticRoutes([]);
  }

  ngOnInit(): void {
    if (this.auth.isLoggedIn()) {
      this.catalogRouting.searchDefault();
    }
  }

  isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }

  onLogin(): void {
    const loginRedirectUrl = this.authRepository.loginRedirectUrl;

    this.auth.login({
      redirectUri: `${loginRedirectUrl ? loginRedirectUrl : baseUrl()}`
    });
  }
}
